import { useState, useCallback } from 'react';

export const useCurrencyFormatter = () => {
  const [decimalPointEnabled, setDecimalPointEnabled] = useState(false);
  const [formattedAmount, setFormattedAmount] = useState("$ 0,00");
  const [rawAmount, setRawAmount] = useState(0);
  const [helperText, setHelperText] = useState("");

  const formatCurrency = useCallback((num) => {
    if (isNaN(num)) return "$ 0,00";
    return num.toLocaleString("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 2,
    });
  }, []);

  const handleAmountChange = useCallback((e) => {
    const nativeEvent = e.nativeEvent;
    const keyPressed = nativeEvent.data;
    const isBackspace = nativeEvent.inputType === "deleteContentBackward";
    let inputValue = e.target.value ?? "";

    // Toggle decimal point
    if (keyPressed === "," || keyPressed === ".") {
      setDecimalPointEnabled(!decimalPointEnabled);
      setHelperText(!decimalPointEnabled ? "Ingreso de decimales habilitado" : "");
      
      if (decimalPointEnabled) {
        inputValue = inputValue.replace(/[^0-9,]/g, "").replace(/,\d+/g, "");
        const num = parseFloat(inputValue.replace(",", "."));
        if (!isNaN(num)) {
          setFormattedAmount(formatCurrency(num));
          setRawAmount(num);
        }
      }
      return;
    }

    // Handle decimal input
    if (decimalPointEnabled) {
      if (!isBackspace) {
        inputValue = inputValue.replace(/[^0-9,]/g, "").replace(/,0(?=\d)/g, ",");
      } else {
        if (inputValue !== "") {
          let [integerStr, decimalStr = ""] = inputValue.split(",");
          integerStr = integerStr?.replace(/\D/g, "") || "";
          decimalStr = decimalStr?.slice(0, -1) || "";
          inputValue = integerStr + (decimalStr ? "," + decimalStr : "");
        }
      }
    } else {
      // Handle integer input
      if (isBackspace) {
        let [integerStr = ""] = inputValue.split(",");
        integerStr = integerStr.replace(/\D/g, "").slice(0, -1);
        inputValue = integerStr;
      } else {
        inputValue = inputValue.replace(/[^0-9,]/g, "").replace(/,00/g, "");
      }
    }

    const num = parseFloat(inputValue.replace(",", "."));
    if (!isNaN(num) && num > 0) {
      setFormattedAmount(formatCurrency(num));
      setRawAmount(num);
    } else {
      setFormattedAmount("$ 0,00");
      setRawAmount(0);
    }
  }, [decimalPointEnabled, formatCurrency]);

  const reset = useCallback(() => {
    setDecimalPointEnabled(false);
    setFormattedAmount("$ 0,00");
    setRawAmount(0);
    setHelperText("");
  }, []);

  return {
    formattedAmount,
    formatCurrency,
    rawAmount,
    helperText,
    handleAmountChange,
    reset,
  };
};